import React from 'react';
import { Button } from 'react-bootstrap';

import { assembleNickname } from "utils/Helper.js";
// , get_current_unix_stamp
import ringtone from 'Assets/audio/dodgethis-phone-ringtone.mp3';

var Sound = require('react-sound').default;

class RingTophat extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }
  
  answerRing = () => {
    if (this.props.OnAnswerRing) {
      this.props.OnAnswerRing(this.props.ring_info.chat);
    }
  }

  dismissRing = () => {
    if (this.props.OnDismissRing) {
      this.props.OnDismissRing(this.props.ring_info.chat);
    }
  }
  
  render() {
    let nickname = "";
    if (this.props.ring_info) {
      nickname = assembleNickname(this.props.ring_info['caller']);
    }
    
    return (
      <React.Fragment>
        {this.props.ring_info &&
          <div className="sub-nav">
            <div className="sub-menu-nav tophat bg-info">
              <div className="container">
                {nickname} is calling you! &nbsp;&nbsp;
                <Button variant="success" style={{ marginTop: "-3px", marginRight: "5px" }} onClick={this.answerRing}>Connect to Call</Button>
                <Button variant="danger" style={{ marginTop: "-3px" }} onClick={this.dismissRing}>Dismiss</Button>
                <Sound
                  url={ringtone}
                  playStatus={Sound.status.PLAYING}
                  autoLoad={true}
                />
                {/*
                {this.state.tophat_info.text_content}
                { this.state.tophat_info.link_url.startsWith('https://') ?
                  <a target="_blank" style={{ textDecoration: "underline", color: "white" }} href={this.state.tophat_info.link_url}>{this.state.tophat_info.link_text}</a>
                  :
                  <Link style={{ textDecoration: "underline", color: "white" }} to={this.state.tophat_info.link_url}>{this.state.tophat_info.link_text}</Link>
                }
                */}
              </div>
            </div>
          </div>
        }
      </React.Fragment>
    );
  }
}

export default RingTophat;